export default "/packs/images/walkietalkie~d6f2aae7d1152aeb8996fed04596b66a.png";